<div class="container container--mobile-padding page-not-found">
	<h1>{{ "NOT_FOUND.TITLE" | translate }}</h1>
	<h2>{{ "NOT_FOUND.TEXT" | translate }}</h2>
	<a [routerLink]="['/'+currentLang]" class="page-not-found__link">{{ "NOT_FOUND.LINK" | translate }}</a>
</div>
